/**
 * Template for Displaying the Plugin's Settings page using React Components
 * @package Custom Welcome Guide
 * @since 1.0.0
 * @see https://wholesomecode.ltd/wordpress/create-settings-page-wordpress-gutenberg-components/
 */

import { render } from '@wordpress/element';
import { dispatch } from '@wordpress/data';
import FeaturedGuide from './featured-guide';
import './admin.scss';

/**
 * Determine whether to show the featured guide in the whole WordPress Admin
 * Based on plugin options
 * @since 1.0.1
 */
const FeaturedGuideinWholeAdmin = () => {
	// Disable for now.
	return null;

	const isBlockEditor = document.body.className.indexOf( 'block-editor-page' ) > -1;

	if ( isBlockEditor || typeof pixcareSiteGuides === 'undefined' ) return null;

	return (
		<FeaturedGuide/>
	);
};

document.addEventListener( 'DOMContentLoaded', () => {
	const popup = document.createElement( 'div' );
	const body = document.body.appendChild( popup );
	if ( body ) {
		render(
			<FeaturedGuideinWholeAdmin/>,
			body
		);
	}
	// keep the editor panel open by default
	if ( !localStorage.getItem( 'pixcare-site-guides-editor-panel-open' ) ) {
		if ( dispatch( 'core/edit-post' ) !== null ) {
			dispatch( 'core/edit-post' ).toggleEditorPanelOpened( 'site-guides-plugin-panel/pixcare-site-guides-edit-post' );
		}
		localStorage.setItem( 'pixcare-site-guides-editor-panel-open', 'yes' );
	}

} );
